/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/guards/app.guards.haslieferkunde.ts.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment} from '@angular/router';
import {AppMessageService} from '../services/app.message.service';
import {Observable, of} from 'rxjs';
import {AppLieferkundeService} from '../services/app.lieferkunde.service';
import {Lieferkunde} from '../models/lieferkunde';
import {AppEventService} from '../services/app.event.service';
import {AppLogService} from '../services/app.log.service';
import {AppMemoryService} from '../services/app.memory.service';

/**
 * Zweck: Beschreibt class AppGuardsHasLieferkunde und ihren Daten- oder Funktionsvertrag.
 */
@Injectable()
export class AppGuardsHasLieferkunde  {
  lieferkunde: Lieferkunde;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private router: Router, private lksvc: AppLieferkundeService, private msg: AppMessageService,
              private esvc: AppEventService, private logger: AppLogService, private memsvc: AppMemoryService) {
    this.lksvc.current_lieferkunde$.subscribe(lk => this.lieferkunde = lk);
  }

/**
 * Beschreibt Methode testIsLieferkundeLoaded und ihren Rückgabevertrag.
 */
  testIsLieferkundeLoaded() {
    return (this.lksvc.current_lieferkunde.value instanceof Lieferkunde);
  }

/**
 * Beschreibt Methode canActivate und ihren Rückgabevertrag.
 */
  canActivate(route: ActivatedRouteSnapshot, rtsnap: RouterStateSnapshot): Observable<boolean> {
    const isLieferkundeLoaded = this.testIsLieferkundeLoaded();
    if (isLieferkundeLoaded) {
      return of(true);
    } else {
      this.logger.consoleDebug(this, 'canActivate - ' + route.url + ' -> Kein Lieferkunde geladen. Redirect to /lieferkunden');
      this.memsvc.set('lieferkunde-selector_redirurl', rtsnap.url);
      this.router.navigateByUrl('/lieferkunden');
    }
  }

/**
 * Beschreibt Methode canActivateChild und ihren Rückgabevertrag.
 */
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const isLieferkundeLoaded = this.testIsLieferkundeLoaded();
    this.logger.consoleDebug(this, 'canActivateChild - ' + childRoute.url + ' -> Kein Lieferkunde geladen');
    return of(isLieferkundeLoaded);
  }

/**
 * Beschreibt Methode canLoad und ihren Rückgabevertrag.
 */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const isLieferkundeLoaded = this.testIsLieferkundeLoaded();
    this.logger.consoleDebug(this, 'canLoad - ' + route.path + ' -> Kein Lieferkunde geladen');
    return of(isLieferkundeLoaded);
  }
}
